const commentKey = (comment = {}) => {
  const author = comment.author || '';
  const permlink = comment.permlink || '';
  return `${author}/${permlink}`;
};

const parentKey = (comment = {}) => {
  const parentAuthor = comment.parentAuthor || comment.parent_author || '';
  const parentPermlink = comment.parentPermlink || comment.parent_permlink || '';
  return `${parentAuthor}/${parentPermlink}`;
};

export const buildCommentTree = (flatComments = [], rootAuthor = '', rootPermlink = '') => {
  const map = {};
  const roots = [];

  flatComments.forEach((comment) => {
    map[commentKey(comment)] = { ...comment, replies: [] };
  });

  flatComments.forEach((comment) => {
    const node = map[commentKey(comment)];
    const isRootReply =
      (comment.parentAuthor || comment.parent_author) === rootAuthor &&
      (comment.parentPermlink || comment.parent_permlink) === rootPermlink;

    if (isRootReply) {
      roots.push(node);
      return;
    }

    const parent = map[parentKey(comment)];
    if (parent) {
      parent.replies.push(node);
    }
  });

  return roots;
};

export const flattenCommentTree = (nestedComments = []) => {
  const out = [];

  const walk = (nodes = []) => {
    nodes.forEach((node) => {
      const children = Array.isArray(node.replies) ? node.replies : [];
      out.push({ ...node, replies: [] });
      if (children.length > 0) {
        walk(children);
      }
    });
  };

  walk(nestedComments);
  return out;
};
